<template>
    <div>      
        

        <div class="form-group row original" style="padding-top:30px" >
            <div class="col-md-3">
                <label>Amount</label>
                <h2>RS: {{ data.amount }}</h2>
            </div>

            <div class="col-md-3">
                <label>Tickets</label>
                <h2>{{ data.tickets }}</h2>
            </div> 
            
            <div class="col-md-6">
                <label>Invoice ID</label>
                <h2>{{ data.invoice_id }}</h2>
            </div>

        </div>            

        <div class="form-group row" v-can="'Reverse Invoice'">
            
            <div
                class="col-md-6 login-content"              
                style="display: block"
            >
                <div class="form-group row" style="margin-bottom: 0px">
                    <!-- Reverse log-->
                    <div
                        class="input-div"
                        :class="{
                            'is-invalid input-div-err focus':
                                $v.ReversFields.reason.$error || errors.log,
                            ' is-valid focus': !$v.ReversFields.reason.$invalid,
                        }"
                    >
                        <div class="i">
                            <i class="fas fa-ticket-alt"></i>
                        </div>
                        <div class="div">
                            <label
                                for="reason"
                                class="col-md-12 col-form-label text-md-left"
                                >Reverse Log</label
                            >
                            <input
                                type="text"
                                class="input form-control"
                                :class="{
                                    'is-invalid focus':
                                        $v.ReversFields.reason.$error ||
                                        errors.log,
                                    ' is-valid focus':
                                        !$v.ReversFields.reason.$invalid,
                                }"
                                v-model="ReversFields.reason"
                                name="reason"
                                id="reason"
                                @input="$v.ReversFields.reason.$touch()"
                                @blur="$v.ReversFields.reason.$touch()"
                            />
                        </div>
                    </div>

                    <span
                        class="invalid-feedback"
                        v-if="$v.ReversFields.reason.$error"
                        >
                        <p v-if="!$v.ReversFields.reason.required">
                            The Reverse log field is required.
                        </p>                 
                    </span>         
                    <!-- End Reverse log -->
                </div>
            </div>          

            <div
                class="col-md-6 login-content"
                style="display: block"
                v-if="!enableReverse"
            >
                <form @submit.prevent="getPermission()">
                    <div class="row">
                        <div class="col-md-6">
                            <div
                                class="input-div"
                                :class="{
                                    'is-invalid input-div-err focus':
                                        $v.Authorization.empID.$error ||
                                        errors.empID,
                                    ' is-valid focus':
                                        !$v.Authorization.empID.$invalid,
                                }"
                            >
                                <div class="i">
                                    <i class="fas fa-ticket-alt"></i>
                                </div>
                                <div class="div">
                                    <label
                                        for="empID"
                                        class="col-md-12 col-form-label text-md-left"
                                        >Officer Employee ID</label
                                    >
                                    <input
                                        type="text"
                                        class="input form-control"
                                        :class="{
                                            'is-invalid focus':
                                                $v.Authorization.empID.$error ||
                                                errors.empID,
                                            ' is-valid focus':
                                                !$v.Authorization.empID.$invalid,
                                        }"
                                        v-model="Authorization.empID"
                                        name="empID"
                                        id="empID"
                                        @input="$v.Authorization.empID.$touch()"
                                        @blur="$v.Authorization.empID.$touch()"
                                    />
                                </div>
                            </div>

                            <span
                                class="invalid-feedback"
                                v-if="$v.Authorization.empID.$error"
                            >
                                <p v-if="!$v.Authorization.empID.required">
                                    The Officer Employee ID field is required.
                                </p>
                            </span>
                        </div>

                        <div class="col-md-6">
                            <div
                                class="input-div"
                                :class="{
                                    'is-invalid input-div-err focus':
                                        $v.Authorization.empPassword.$error ||
                                        errors.empPassword,
                                    ' is-valid focus':
                                        !$v.Authorization.empPassword.$invalid,
                                }"
                            >
                                <div class="i">
                                    <i class="fas fa-lock"></i>
                                </div>
                                <div class="div">
                                    <label
                                        for="empPassword"
                                        class="col-md-12 col-form-label text-md-left"
                                        >Officer Employee Password</label
                                    >
                                    <input
                                        type="password"
                                        class="input form-control"
                                        :class="{
                                            'is-invalid focus':
                                                $v.Authorization.empPassword
                                                    .$error ||
                                                errors.empPassword,
                                            ' is-valid focus':
                                                !$v.Authorization.empPassword
                                                    .$invalid,
                                        }"
                                        v-model="Authorization.empPassword"
                                        name="empPassword"
                                        id="empPassword"
                                        @input="
                                            $v.Authorization.empPassword.$touch()
                                        "
                                        @blur="
                                            $v.Authorization.empPassword.$touch()
                                        "
                                    />
                                </div>
                            </div>

                            <span
                                class="invalid-feedback"
                                v-if="$v.Authorization.empPassword.$error"
                            >
                                <p
                                    v-if="
                                        !$v.Authorization.empPassword.required
                                    "
                                >
                                    The Officer Employee Password field is
                                    required.
                                </p>
                            </span>
                        </div>
                    </div>

                    <button
                        type="submit"
                        class="btn-small-width btn-invoice btn-danger"
                        id="permissionBtn"
                        :disabled="disabledStatus"
                        v-on:keyup.enter="getPermission()"
                    >
                        Get Permission
                    </button>
                </form>
            </div>

            <div
                class="col-md-4 login-content"
                style="display: block"
                v-if="enableReverse"
            >
                <button
                    type="btn"
                    :class="btnClass"
                    id="ReversLogBtn"
                    @click="ReverseLog()"
                >
                    Reverse Ticket
                </button>
            </div>
            <!-- End reverse ticket-->
        </div>   
        
    </div>
</template>

<style scoped>
form {
    width: 100%;
}

p {
    font-size: 15px;
    margin: 0px;
}

.card-single {
    padding: 1rem;
    background-color: #e8daef;
}

th,
td {
    border: 1px solid black;
}

.original h2,
label {
    color: #8e44ad;
    font-weight: bold;
}

.btn-invoice-background-err {
    background-color: #cb4335;
}

.btn-invoice-background-refund-start {
    background-color: #239b56;
}
</style>

<script>
import { required } from "vuelidate/lib/validators";
const config = {
    headers: {
        "Content-Type": "multipart/form-data",
        Accept: "application/json",
    },
};

export default { 

    created() {
          this.data=this.invoice;
          this.ramount=this.refundQty,
          this.rqty=this.refundAmount
    },
    props: [
        "invoice",
        "refundQty",
        "refundAmount"       
    ],

    data() {
        return {
            data:"",
            ramount:"",
            rqty:"",        
            errors: {},
            btnClass: "btn-small-width btn-invoice",
            disabledStatus: false,
            enableReverse: false,
            Authorization: {
                empID: "",
                empPassword: "",
            },
            ReversFields: {
                type: "print_error",
                reason:""
            },          
        };
    },

    validations: {
      

        Authorization: {
            empID: { required },
            empPassword: { required },
        },
        ReversFields: {
            reason:{required}
        },       
    },

    methods: {      
        getPermission() {
            this.$v.Authorization.$touch();
            if (this.$v.Authorization.$invalid) {
                return;
            }

            this.disabledStatus = true;
            this.errors = {};
            $("#permissionBtn").html(
                '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span> | </div> Getting Permission...'
            );

            const formData = new FormData();
            formData.append("empID", this.Authorization.empID);
            formData.append("empPassword", this.Authorization.empPassword);

            axios
                .post("/cashier/request-reverse", formData, config)
                .then((response) => {
                    if (response.data.data == true) {
                        this.enableReverse = true;
                        Toast.fire({
                            icon: "success",
                            title: "Enable To reverse",
                        });
                    } else {
                        this.disabledStatus = false;
                        $("#permissionBtn").text(
                            "Getting Permission Failed Try Again ..."
                        );
                        Toast.fire({
                            icon: "error",
                            title: "Password Not Match",
                        });
                    }
                })
                .catch((error) => {
                    this.disabledStatus = false;
                    $("#permissionBtn").text(
                        "Getting Permission Failed Try Again ..."
                    );

                    if (error.response.status == 422) {
                        this.errors = error.response.data.errors;
                        Toast.fire({
                            icon: "error",
                            title: error.response.data.errors.message,
                        });
                    } else if (error.response.status == 500) {
                        Toast.fire({
                            icon: "error",
                            title: error.response.data.errors.message,
                        });
                    }
                });
        },

        ReverseLog(){
            this.$v.ReversFields.$touch();
            if (this.$v.ReversFields.$invalid) {
                return;
            }

            const formData = new FormData();
            formData.append("invoice", this.data.invoice_id);
            formData.append("type", this.ReversFields.type);
            formData.append("log", this.ReversFields.reason);
            axios
                .post("/cashier/reverse-invoice", formData, config)
                .then((response) => {
                    Toast.fire({
                            icon: "success",
                            title: "Invoice Reversed",
                            text: "Reversed",
                        });
                })
                .catch((error) => {                   

                    if (error.response.status == 422) {
                        this.errors = error.response.data.errors;
                    } else if (
                        error.response.data.errors.message == "error"
                    ) {
                        Toast.fire({
                            icon: "error",
                            title: "Error",
                            text: "Something Wrong",
                        });
                    } else if (error.response.status == 500) {
                        Toast.fire({
                            icon: "error",
                            title: error.response.data.errors.message,
                        });
                    } else {
                        Toast.fire({
                            icon: "error type 2",
                            title: error.response.data.errors.message,
                        });
                    }
                });
        },        
            
    },
};
</script>
